<template>
    <div class="modal-overlay">
      <div class="modal-container modal-full-width">
        <!-- Cabeçalho -->
        <div class="modal-header">
          <h6>Selecione os Turnos de Preferência</h6>
          <i class="bi bi-x-circle close-icon" @click="cancel"></i>
        </div>
        <div class="spacer"></div>
  
        <!-- Corpo do Modal -->
        <div class="modal-content">
          <h5 class="section-title"></h5>
          <div class="form-group" v-for="option in options" :key="option.value">
            <div class="form-check">
              <input 
                type="checkbox" 
                :id="option.value" 
                :value="option.value" 
                v-model="selected" 
                class="form-check-input" />
              <label class="form-check-label" :for="option.value">{{ option.text }}</label>
            </div>
          </div>
        </div>
  
        <!-- Rodapé (Ações) -->
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary me-2" @click="cancel">Cancelar</button>
          <button type="button" class="btn btn-primary me-2" :disabled="selected.length === 0" @click="confirmSelection">Confirmar</button>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: 'TurnosPreferenciaModal',
    props: {
      isOpen: {
        type: Boolean,
        default: false
      },
      initialValue: {
        type: Array,
        default: () => []
      }
    },
    data() {
      return {
        selected: []
      };
    },
    computed: {
      options() {
        return [
          { value: 'Indiferente', text: 'Indiferente' },
          { value: 'Não informado', text: 'Não informado' },
          { value: 'Matutino', text: 'Matutino' },
          { value: 'Vespertino', text: 'Vespertino' },
          { value: 'Noturno', text: 'Noturno' }
        ];
      }
    },
    watch: {
      isOpen: {
        handler(newVal) {
          if (newVal) {
            this.selected = [...this.initialValue];
          }
        },
        immediate: true
      }
    },
    methods: {
      confirmSelection() {
        const value = this.selected.join(', ');
        this.$emit('confirm', value);
        this.$emit('close');
      },
      cancel() {
        this.$emit('close');
      }
    }
  };
  </script>
  
  <style scoped>
  .modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    z-index: 9999;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .modal-container {
    background: #fff;
    width: 100%;
    max-width: 25%;
    height: auto;
    overflow-y: auto;
    margin: 0 auto;
    border-radius: 0px;
  }
  .modal-header {
    background: #ccc;
    padding: 10px 15px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .close-icon {
    font-size: 1.5rem;
    cursor: pointer;
  }
  .spacer {
    margin-bottom: 20px;
  }
  .modal-content {
    padding: 10px 15px;
  }
  .section-title {
    font-size: 0.9rem;
    font-weight: bold;
    margin-bottom: 10px;
  }
  .form-group {
    margin-bottom: 10px;
  }
  .form-check {
    display: flex;
    align-items: center;
    margin-left: 20px;
  }
  .form-check-input {
    margin-right: 8px;
  }
  .modal-footer {
    display: flex;
    justify-content: flex-end;
    padding: 20px;
  }
  .btn-secondary {
    background-color: #6c757d;
    border: none;
    padding: 6px 10px;
    color: #fff;
    border-radius: 4px;
    cursor: pointer;
  }
  .btn-primary {
    background-color: #007bff;
    border: none;
    padding: 6px 20px;
    color: #fff;
    border-radius: 4px;
    cursor: pointer;
  }
  .btn-primary:disabled {
    background-color: #aaa;
    cursor: not-allowed;
  }
  </style>
  